export function getMissingTransactionProfileRequirements(profile) {
  const missing = [];
  if (!profile?.public_barangay_code) {
    missing.push('City/Municipality and Barangay');
  }
  if (!profile?.public_avatar_path) {
    missing.push('profile photo');
  }
  return missing;
}

export function getTransactionProfileCompletionMessage(profile, action) {
  const tasks = [];
  if (!profile?.public_barangay_code) {
    tasks.push('select a City/Municipality and Barangay from the official list');
  }
  if (!profile?.public_avatar_path) {
    tasks.push('upload a profile photo');
  }
  if (!tasks.length) return '';
  return `Before ${action}, ${tasks.join(' and ')} in the Profile tab.`;
}
